import { Col } from "antd";
import React from "react";

export const FirstRow = (props) => {
  const { tnavfirst, tnavsecond, tnavthird } = props;
  return (
    <>
      {tnavfirst && (
        <Col flex={1} className="first-row">
          <ul>
            {tnavfirst.map((item) => (
              <li className={item.classes[0]}>
                <a href={item.url}>{item.title}</a>
              </li>
            ))}
          </ul>
        </Col>
      )}
      {tnavsecond && (
        <Col flex={1} className="first-row">
          <ul>
            {tnavsecond.map((item) => (
              <li className={item.classes[0]}>
                <a href={item.url}>{item.title}</a>
              </li>
            ))}
          </ul>
        </Col>
      )}

      {tnavthird && (
        <Col flex={1} className="first-row">
          <ul>
            {tnavthird.map((item) => (
              <li className={item.classes[0]}>
                <a href={item.url}>{item.title}</a>
              </li>
            ))}
          </ul>
        </Col>
      )}
    </>
  );
};

export default FirstRow;
